import { render, staticRenderFns } from "./AllGiftsMenu.vue?vue&type=template&id=182e72f6&scoped=true&"
import script from "./AllGiftsMenu.vue?vue&type=script&lang=js&"
export * from "./AllGiftsMenu.vue?vue&type=script&lang=js&"
import style0 from "./AllGiftsMenu.vue?vue&type=style&index=0&id=182e72f6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182e72f6",
  null
  
)

export default component.exports